export default __webpack_public_path__ + "static/media/foxxy_simple.7796ecef.svg";